import { Injectable, inject } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly storageService = inject(StorageService);
  isBackEnable = true;

  hasPermission(permission: string): boolean {
    const raw = this.storageService.currentIdentity()?.permissions;
    const permissions = Array.isArray(raw) ? raw : (raw ?? '').split(',');
    return permissions.some(value => value.trim() === permission.trim());
  }

  hasRole(role: string): boolean {
    const value = role.trim().toUpperCase();
    return this.storageService.getRoles().some(item => item.trim().toUpperCase() === value);
  }

  isTeamLead(): boolean { return !!this.storageService.currentIdentity()?.isTeamLeader; }
  getUserId(): string | number | null { return this.storageService.getUserId(); }
  getUserName(): string | null { return this.storageService.getUserName(); }
}
